import { useFrame, useThree } from "@react-three/fiber";
import { useMemo } from "react";
import { PerspectiveCamera, Vector3 } from "three";

import type { AlphaBattlefieldCameraState } from "../alpha/camera/battlefield-camera-types";
import { getPerspectiveCameraCalibration } from "../alpha/presentation/perspective-layout";

export function BattlefieldCameraDirector({
  cameraState,
  reducedMotion,
}: {
  readonly cameraState: AlphaBattlefieldCameraState;
  readonly reducedMotion: boolean;
}) {
  const size = useThree((state) => state.size);
  const calibration = getPerspectiveCameraCalibration({
    width: size.width,
    height: size.height,
    cameraState,
  });
  const targetPosition = useMemo(() => new Vector3(), []);
  const targetLookAt = useMemo(() => new Vector3(), []);
  const currentLookAt = useMemo(() => new Vector3(0, 0, -0.72), []);

  useFrame(({ camera }, delta) => {
    if (camera instanceof PerspectiveCamera && Math.abs(camera.fov - calibration.fov) >= 0.01) {
      camera.fov = calibration.fov;
      camera.updateProjectionMatrix();
    }
    targetPosition.set(...calibration.position);
    targetLookAt.set(...calibration.target);
    const blend = reducedMotion ? 1 : 1 - Math.exp(-7.5 * delta);
    camera.position.lerp(targetPosition, blend);
    currentLookAt.lerp(targetLookAt, blend);
    camera.lookAt(currentLookAt);
  });

  return null;
}
